import { Entity } from '@nx-smartmonkey/shared/domain';

export interface FlatProjectProps {
  label?: string;
  avatar_url?: string;
  description?: string;
  users: number;
}

export class FlatProject extends Entity<FlatProjectProps> {
  private _avatar: string | undefined;

  get id(): string {
    return this._id!;
  }
  get label(): string | undefined {
    return this.props.label;
  }
  set label(label: string | undefined) {
    this.props.label = label;
  }
  get description(): string | undefined {
    return this.props.description;
  }
  set description(description: string | undefined) {
    this.props.description = description;
  }
  get avatar_url(): string | undefined {
    return this.props.avatar_url;
  }
  set avatar_url(avatar_url: string | undefined) {
    this.props.avatar_url = avatar_url;
  }
  get project_avatar(): string | undefined {
    return this._avatar;
  }
  set project_avatar(project_avatar: string | undefined) {
    this._avatar = project_avatar;
  }
  get users(): number {
    return this.props.users;
  }

  protected constructor(props: FlatProjectProps, id?: string) {
    super(props, id);
  }

  static create(props: FlatProjectProps, id?: string) {
    return new FlatProject(props, id);
  }
}
